import produce from "immer";

const INITIAL_STATE = {
  documentsList: [],
  approvalDocumentsLoading: false,
};

const approvalDocument = (state = INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case "FETCH_DOCUMENTS_LIST": {
        draft.approvalDocumentsLoading = true;
        break;
      }

      case "SET_DOCUMENTS_LIST": {
        const { documentsList } = action.payload;
        draft.documentsList = documentsList;
        draft.approvalDocumentsLoading = false;
        break;
      }

      case "SET_APPROVAL_DOCUMENTS_LOADING": {
        const { loading } = action.payload;
        draft.approvalDocumentsLoading = loading;
        break;
      }

      default:
        return draft;
    }
  });
};

export default approvalDocument;
